import(/* webpackMode: "eager" */ "/vercel/path0/fastpeps-core-storefront/src/app/[countryCode]/(main)/faq/page.tsx");
